export default {
    "palette": {
        "primary": {
            "main": "#b20217"
        },
        "background": {
            "default": "#ffffff"
        },
        "secondary": {
            "main": "#ffcd00"
        }
    },
    "typography": {
        "subtitle1": {
            "fontWeight": 700
        },
        "fontSize": 16,
        "htmlFontSize": 16,
        "h6": {
            "lineHeight": "1.334"
        }
    },
    "googleFonts": [
        "Roboto:100,100italic,300,300italic,regular,italic,500,500italic,700,700italic,900,900italic"
    ],
    "props": {
        "MuiCard": {
            "elevation": 1
        }
    },
    "overrides": {
        "MuiCssBaseline": {
            "@global": {
                "body": {
                    "--padding-unit": "min(64px, 10vmin)",
                    "--override-top-padding": "0"
                }
            }
        },
        "MuiCard": {
            "root": {
                "border": "1px solid #bdbdbd"
            }
        }
    }
};